import React from 'react'
import { Link } from 'react-router-dom'

const SignupLink: React.FC = () => {
  return <Link to="/register">Register{''}</Link>
}

export default SignupLink
